import BetSlipContainer from '@modules/sportOffer/betSlip/BetSlipContainer.vue';
import UserSelectionsContainer from '@modules/sportOffer/UserSelectionsContainer.vue';

export const superAdvantagePage = {
    content: () => import('@pages/SuperAdvantagePage/SuperAdvantagePage.vue'),
    leftSidebar: () => import('@app/shared/modules/sportOffer/SdsSuperAdvantageSportsSidebar.vue'),
    mobileHeader: () => import('@pages/SuperAdvantagePage/SuperAdvantageMobileHeader.vue'),
    rightSidebar: BetSlipContainer,
    mobileBottomContent: UserSelectionsContainer,
};
